import { useCallback, useRef, useState } from 'react'

export function useCopyToClipboard(resetDelay = 2000) {
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef(null)

  const copy = useCallback(
    async (text) => {
      await navigator.clipboard.writeText(text || '')
      setCopied(true)

      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => setCopied(false), resetDelay)
    },
    [resetDelay],
  )

  return { copied, copy }
}
